import {SubtitleItem, TitleState} from '../state/title.state';
import * as TitleActions from '../actions/title.actions';

const initialState: TitleState = {
  buttons: [],
  displayIcon: null,
  displayTitle: '',
  displaySubtitle: [],
  breadcrumbs: [],
  weatherLocation: null,
};

export function TitleReducer(state: TitleState = initialState, action: TitleActions.Actions): TitleState {
  switch (action.type) {
    case TitleActions.TITLE_CHANGE:
      const subtitle: SubtitleItem[] = [...action.displaySubtitle];

      // If the subtitle array contains an empty string, wipe it out
      // so there isn't an empty pill rendered in the title area
      if (action.displaySubtitle && action.displaySubtitle.length && !action.displaySubtitle[0].text) {
        subtitle.length = 0;
      }

      return {
        ...state,
        buttons: action.buttons,
        displayIcon: action.displayIcon,
        displayTitle: action.displayTitle,
        displaySubtitle: subtitle,
        weatherLocation: action.weatherLocation,
      };
    case TitleActions.TITLE_BREADCRUMBS_CHANGE:
      return {
        ...state,
        breadcrumbs: action.breadcrumbs,
      };
    default:
      return state;
  }
}
